const units = {
  toast: {
    error: {
      badResponse: '[Unit] bad server response',
      create: {},
      edit: {},
    },
    success: {
      create: { default: 'Site created successfully' },
      edit: {},
      delete: {
        default: 'Sites were deleted successfully',
      },
    },
  },
  headerButtons: {
    create: 'Create',
    delete: {
      label: 'Delete',
      deleteModal: {
        header: 'Delete Units',
        body: 'You are about to delete {{units}} units',
      },
    },
  },

  create: {
    errorToast: {
      message: 'Error Occurred. Could Not Create Site',
    },
    duplicateToast: {
      message: 'Site with that name already exists',
    },
    successToast: {
      message: 'Success! Site Added Successfully',
    },
  },

  edit: {
    errorToast: {
      message: 'Error Occurred. Could Not Update Site',
    },
    successToast: {
      message: 'Success! Site Updated Successfully',
    },
  },

  delete: {
    errorToast: {
      message: 'Error Occurred. Could Not Delete Site',
    },
    successToast: {
      message: 'Success! Site Deleted Successfully',
    },
    deleteViewSite: {
      message: 'View site can\'t be deleted',
    },
  },

  form: {
    header: {
      create: {
        title: 'Create',
      },

      update: {
        title: 'Update',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
      },
    },

    information: {
      details: {
        header: 'Details',
        fields: {
          name: 'Name',
        },
      },
      information: {
        header: 'Information',
        fields: {
          operation: {
            title: 'Operation',
            options: {
              default: 'Default',
              school: 'School',
              NEMT: 'NEMT',
              microtransit: 'Microtransit',
              airportShuttle: 'Airport Shuttle',
              employee: 'Employee',
              deliveries: 'Deliveries',
              evs: 'EVs',
              broker: 'Broker',
            },
          },
          schoolOperationsEnabled: {
            title: 'Allow School',
          },
          employeeOperationsEnabled: {
            title: 'Allow Workplace'
          },
        },
      },
      contactUsInformation: {
        header: 'Mobile App Contact Us Information',
        fields: {
          address: 'Address',
          phone: 'Phone',
          email: 'Email',
        },
      },
    },
    valdations: {
      name: {
        required: 'Name is required',
        name: 'Invalid Name',
      },
    },
  },
  table: {
    headers: {
      name: 'name',
      operation: 'operation',
    },
    actions: {
      delete: 'Delete',
      export: 'Export',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
};

export default units;
